import { Button, ButtonLevel, ButtonSize } from '@vizit/atoms';
import { AmazonIcon, LockIcon, PuzzlePiece02Icon, ShieldCheckIcon } from '@vizit/icons';
import { Dialog, DialogHeaderStatus, DialogHeaderVariant } from '@vizit/molecules';
import { AmazonToVizitRow } from '../../amazon-to-vizit-row';
import { AVC_CONNECT_MODAL_COPY } from '../avc-connect-modal.constants';
import { useAvcConnect } from '../provider/avc-connect.context';

const COPY = AVC_CONNECT_MODAL_COPY.intro;

function TrustRow() {
  return (
    <div className="flex items-center justify-center gap-16 pt-4">
      <div className="flex items-center gap-3 text-success-600">
        <LockIcon size={16} aria-hidden="true" />
        <span className="text-xs font-medium">{COPY.readOnly}</span>
      </div>
      <div className="flex items-center gap-3 text-success-600">
        <ShieldCheckIcon size={16} aria-hidden="true" />
        <span className="text-xs font-medium">{COPY.soc2}</span>
      </div>
    </div>
  );
}

function StepIntro() {
  const { isRedirecting, close, startConnect } = useAvcConnect();

  return (
    <>
      <Dialog.Header variant={DialogHeaderVariant.Icon} status={DialogHeaderStatus.Neutral} icon={PuzzlePiece02Icon}>
        <Dialog.Title>{COPY.title}</Dialog.Title>
        <Dialog.Subtitle>{COPY.description}</Dialog.Subtitle>
      </Dialog.Header>

      <div className="mx-auto w-full max-w-[368px] flex flex-col gap-8">
        <AmazonToVizitRow />
        <TrustRow />
      </div>

      <Dialog.Footer>
        <Button
          type="button"
          level={ButtonLevel.Secondary}
          size={ButtonSize.Lg}
          className="flex-1"
          onPress={close}
          isDisabled={isRedirecting}
        >
          {COPY.cancel}
        </Button>
        <Button
          type="button"
          level={ButtonLevel.Primary}
          size={ButtonSize.Lg}
          className="flex-[2]"
          onPress={startConnect}
          isLoading={isRedirecting}
          iconStart={<AmazonIcon size={20} color="white" aria-hidden="true" />}
          data-testid="avc-connect-submit"
        >
          {COPY.submit}
        </Button>
      </Dialog.Footer>
    </>
  );
}

export { StepIntro };
